/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ count: NonNullable<unknown> }} Profile_Activity_DetailInputs */

const id_profile_activity_detail = /** @type {(inputs: Profile_Activity_DetailInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.count} pencapaian terbuka`)
};

const ms_profile_activity_detail = /** @type {(inputs: Profile_Activity_DetailInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.count} pencapaian dibuka`)
};

const da_profile_activity_detail = /** @type {(inputs: Profile_Activity_DetailInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.count} achievement-oplåsninger`)
};

const de_profile_activity_detail = /** @type {(inputs: Profile_Activity_DetailInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.count} Errungenschaften freigeschaltet`)
};

const en_us2_profile_activity_detail = /** @type {(inputs: Profile_Activity_DetailInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.count} achievement unlocks`)
};

const es_es2_profile_activity_detail = /** @type {(inputs: Profile_Activity_DetailInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.count} logros desbloqueados`)
};

const es_mx2_profile_activity_detail = /** @type {(inputs: Profile_Activity_DetailInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.count} logros desbloqueados`)
};

const fil_profile_activity_detail = /** @type {(inputs: Profile_Activity_DetailInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.count} achievement na na-unlock`)
};

const fr_profile_activity_detail = /** @type {(inputs: Profile_Activity_DetailInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.count} succès débloqués`)
};

const it_profile_activity_detail = /** @type {(inputs: Profile_Activity_DetailInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.count} risultati sbloccati`)
};

const hu_profile_activity_detail = /** @type {(inputs: Profile_Activity_DetailInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.count} teljesítmény feloldva`)
};

const nl_profile_activity_detail = /** @type {(inputs: Profile_Activity_DetailInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.count} prestaties ontgrendeld`)
};

const no_profile_activity_detail = /** @type {(inputs: Profile_Activity_DetailInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.count} prestasjoner låst opp`)
};

const pl_profile_activity_detail = /** @type {(inputs: Profile_Activity_DetailInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.count} odblokowanych osiągnięć`)
};

const pt_br2_profile_activity_detail = /** @type {(inputs: Profile_Activity_DetailInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Conquista ${i?.count} desbloqueada`)
};

const pt_profile_activity_detail = /** @type {(inputs: Profile_Activity_DetailInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.count} conquistas desbloqueadas`)
};

const ro_profile_activity_detail = /** @type {(inputs: Profile_Activity_DetailInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.count} realizări deblocate`)
};

const fi_profile_activity_detail = /** @type {(inputs: Profile_Activity_DetailInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.count} saavutusta avattu`)
};

const sv_profile_activity_detail = /** @type {(inputs: Profile_Activity_DetailInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.count} prestationsupplåsningar`)
};

const vi_profile_activity_detail = /** @type {(inputs: Profile_Activity_DetailInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.count} thành tích đã mở khóa`)
};

const tr_profile_activity_detail = /** @type {(inputs: Profile_Activity_DetailInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.count} başarım açılımı`)
};

const cs_profile_activity_detail = /** @type {(inputs: Profile_Activity_DetailInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.count} odemčení úspěchů`)
};

const bg_profile_activity_detail = /** @type {(inputs: Profile_Activity_DetailInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.count} отключвания на постижения`)
};

const ru_profile_activity_detail = /** @type {(inputs: Profile_Activity_DetailInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.count} открыто достижений`)
};

const uk_profile_activity_detail = /** @type {(inputs: Profile_Activity_DetailInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.count} розблокованих досягнень`)
};

const ar_profile_activity_detail = /** @type {(inputs: Profile_Activity_DetailInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.count} إنجاز تم فتحه`)
};

const hi_profile_activity_detail = /** @type {(inputs: Profile_Activity_DetailInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.count} उपलब्धि अनलॉक`)
};

const th_profile_activity_detail = /** @type {(inputs: Profile_Activity_DetailInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.count} การปลดล็อกความสำเร็จ`)
};

const ja_profile_activity_detail = /** @type {(inputs: Profile_Activity_DetailInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.count} 件の実績解除`)
};

const zh_cn2_profile_activity_detail = /** @type {(inputs: Profile_Activity_DetailInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.count} 项成就解锁`)
};

const zh_hant1_profile_activity_detail = /** @type {(inputs: Profile_Activity_DetailInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.count} 項成就解鎖`)
};

const ko_profile_activity_detail = /** @type {(inputs: Profile_Activity_DetailInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`도전 과제 ${i?.count}개 잠금 해제`)
};

/**
* | output |
* | --- |
* | "{count} achievement unlocks" |
*
* @param {Profile_Activity_DetailInputs} inputs
* @param {{ locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }} options
* @returns {LocalizedString}
*/
const profile_activity_detail = /** @type {((inputs: Profile_Activity_DetailInputs, options?: { locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Profile_Activity_DetailInputs, { locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_profile_activity_detail(inputs)
	if (locale === "ms") return ms_profile_activity_detail(inputs)
	if (locale === "da") return da_profile_activity_detail(inputs)
	if (locale === "de") return de_profile_activity_detail(inputs)
	if (locale === "en-US") return en_us2_profile_activity_detail(inputs)
	if (locale === "es-ES") return es_es2_profile_activity_detail(inputs)
	if (locale === "es-MX") return es_mx2_profile_activity_detail(inputs)
	if (locale === "fil") return fil_profile_activity_detail(inputs)
	if (locale === "fr") return fr_profile_activity_detail(inputs)
	if (locale === "it") return it_profile_activity_detail(inputs)
	if (locale === "hu") return hu_profile_activity_detail(inputs)
	if (locale === "nl") return nl_profile_activity_detail(inputs)
	if (locale === "no") return no_profile_activity_detail(inputs)
	if (locale === "pl") return pl_profile_activity_detail(inputs)
	if (locale === "pt-BR") return pt_br2_profile_activity_detail(inputs)
	if (locale === "pt") return pt_profile_activity_detail(inputs)
	if (locale === "ro") return ro_profile_activity_detail(inputs)
	if (locale === "fi") return fi_profile_activity_detail(inputs)
	if (locale === "sv") return sv_profile_activity_detail(inputs)
	if (locale === "vi") return vi_profile_activity_detail(inputs)
	if (locale === "tr") return tr_profile_activity_detail(inputs)
	if (locale === "cs") return cs_profile_activity_detail(inputs)
	if (locale === "bg") return bg_profile_activity_detail(inputs)
	if (locale === "ru") return ru_profile_activity_detail(inputs)
	if (locale === "uk") return uk_profile_activity_detail(inputs)
	if (locale === "ar") return ar_profile_activity_detail(inputs)
	if (locale === "hi") return hi_profile_activity_detail(inputs)
	if (locale === "th") return th_profile_activity_detail(inputs)
	if (locale === "ja") return ja_profile_activity_detail(inputs)
	if (locale === "zh-CN") return zh_cn2_profile_activity_detail(inputs)
	if (locale === "zh-Hant") return zh_hant1_profile_activity_detail(inputs)
	return ko_profile_activity_detail(inputs)
});
export { profile_activity_detail as "profile.activity.detail" }